import { Users, Handshake, TrendingUp } from "lucide-react"

const services = [
  {
    icon: Users,
    title: "Non-Executive & Advisory Support",
    description: "Providing independent challenge, strategic insight and governance support to boards and leadership teams, particularly where cyber risk, trust and regulatory confidence are critical.",
    areas: ["Board Governance", "Strategic Insight", "Independent Challenge"],
  },
  {
    icon: Handshake,
    title: "Senior Stakeholder Engagement",
    description: "Supporting organisations to build effective relationships across government, policing, industry and partners, turning complexity into collaboration.",
    areas: ["Government Relations", "Partnership Building", "Cross-Sector Collaboration"],
  },
  {
    icon: TrendingUp,
    title: "Business Development & Growth",
    description: "Helping organisations strengthen credibility, position propositions and scale initiatives through trusted networks and practical delivery experience.",
    areas: ["Market Positioning", "Network Development", "Initiative Scaling"],
  },
]

const strengths = [
  "Board-level leadership across public, private and third sectors",
  "National programme design, governance and scale-up",
  "Senior stakeholder and partnership engagement",
  "Cyber, fraud and economic crime risk insight",
  "People leadership, mentoring and team development",
]

export function Expertise() {
  return (
    <section id="services" className="py-24 lg:py-32 border-t border-border/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section header */}
        <div className="max-w-3xl mb-20">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-px bg-primary" />
            <span className="text-xs tracking-[0.3em] uppercase text-muted-foreground font-medium">
              What I Do
            </span>
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6 text-balance">
            Strategic support where it matters most
          </h2>
          <p className="text-muted-foreground text-lg leading-relaxed">
            I work on a freelance and advisory basis, supporting boards, founders and senior leaders 
            who value clear governance, strong relationships and credible delivery, particularly 
            in environments where cyber risk, reputation and resilience matter.
          </p>
        </div>

        {/* Services grid */}
        <div className="grid md:grid-cols-3 gap-px bg-border/30 mb-20">
          {services.map((service) => (
            <div 
              key={service.title}
              className="bg-background p-8 lg:p-10 group hover:bg-card transition-colors duration-500"
            >
              <service.icon className="w-8 h-8 text-primary mb-6 group-hover:scale-110 transition-transform duration-300" />
              <h3 className="font-serif text-xl lg:text-2xl mb-4 text-foreground">
                {service.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed mb-6 text-sm">
                {service.description}
              </p>
              <div className="flex flex-wrap gap-2">
                {service.areas.map((area) => (
                  <span 
                    key={area}
                    className="text-xs tracking-wide px-3 py-1.5 border border-border/60 text-muted-foreground"
                  >
                    {area}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Key strengths */}
        <div className="border-t border-border/30 pt-16">
          <h3 className="text-xs tracking-[0.3em] uppercase text-muted-foreground font-medium mb-8">
            Key Strengths
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {strengths.map((strength, index) => (
              <div key={index} className="flex items-start gap-4">
                <span className="text-primary text-lg leading-none">+</span>
                <span className="text-foreground text-sm leading-relaxed">{strength}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
